import { render, staticRenderFns } from "./XdataInsertRowControl.vue?vue&type=template&id=155e8016&scoped=true&"
import script from "./XdataInsertRowControl.vue?vue&type=script&lang=js&"
export * from "./XdataInsertRowControl.vue?vue&type=script&lang=js&"
import style0 from "./XdataInsertRowControl.vue?vue&type=style&index=0&id=155e8016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155e8016",
  null
  
)

export default component.exports